import React from 'react'

type OpenRouteProps = {
	components: Array<any>;
};

// Allow access irrespective to logged in status
const OpenRoute: React.FC<OpenRouteProps> = ({components}) => {
  return (
    <> {components.map((Component, index) => <Component key={index} />)} </>
  )
}

export default OpenRoute